import React from "react";
import { NavLink } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import style from "./header.scss";

const Header = () => {
  const activeStyle = { color: "#c0e3ee" };
  return (
    <div className={style["header"]}>
      <nav>
        <div className={style["main-container"]}>
          <div>
            <NavLink to={ROUTES.LANDING} activeStyle={activeStyle}>
              Home
            </NavLink>
          </div>
          {/* <div>
            <NavLink to="/courses" activeStyle={activeStyle}>
              Courses
            </NavLink>
          </div> */}
          {/* <div>
            <NavLink to={ROUTES.ABOUT} activeStyle={activeStyle}>
              About
            </NavLink>
          </div> */}
          <div>
            <NavLink to={ROUTES.STAR_GAME} activeStyle={activeStyle}>
              Star Game
            </NavLink>
          </div>
          <div>
            <NavLink to={ROUTES.WHATS_APP} activeStyle={activeStyle}>
              What&apos;s App
            </NavLink>
          </div>
          <div>
            <NavLink to={ROUTES.ANALOG_CLOCK} target="_blank">
              Analog Clock
            </NavLink>
          </div>
          {/* <div>
            <NavLink to={ROUTES.GITHUB} activeStyle={activeStyle}>
              Git Hub
            </NavLink>
          </div> */}
        </div>
      </nav>
      <div className={style["download-resume"]}>
        <a id="document_resume" data-type="document" target="_blank">
          <span>DOWNLOAD MY FULL RESUME</span>
        </a>
      </div>
    </div>
  );
};

export default Header;
